import EventBus from '@/utils/eventBus'
import { setToken } from '@/utils/token'
import { touchOneLoginSso } from '@/api/common/login'
import envs from '@/envs'

let cbGetReturnValInTouchOne = function(userSpec, retVal) {
  retVal = decodeURIComponent(retVal)
  userSpec = decodeURIComponent(userSpec)
  let userSpecObj = JSON.parse(userSpec)
  console.log(userSpecObj)
  if (userSpecObj.type === 'userInfo') {
    let returnVal = JSON.parse(retVal)
    touchOneLoginSso(returnVal.UserId)
      .then(response => {
        setToken(response.headers['x-auth-token'])
        EventBus.$emit('touchOneLogin')
      })
      .catch(reject => {
        this.$router.push('/forbidden')
      })
  } else if (userSpecObj.type === 'barcode') {
    EventBus.$emit('barcode', retVal)
  } else if (userSpecObj.type === 'camera') {
    let fileUploadUserSpec = {
      type: 'fileUpload',
      subType: 'camera'
    }
    fileUploadUserSpec = JSON.stringify(fileUploadUserSpec)
    touchOneObj.executeFileUpload(
      'cbGetReturnValInTouchOne',
      fileUploadUserSpec,
      `{ "0": "${retVal}" }`,
      `${envs.uploadUrl}/ashist/savepicture`,
      'True'
    )
  } else if (userSpecObj.type === 'fileUpload') {
    if (userSpecObj.subType === 'camera') {
      EventBus.$emit('imageUpload', retVal)
    }
  }
}

export default cbGetReturnValInTouchOne
